








































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'
import moment from 'moment'
import _ from 'lodash'

@Component
export default class ModalRegraGarantiaMinimaIncluir extends Vue {
  $refs: {
    formRegraGarantiaMinima: any
  }

  formRegraGarantiaMinimaRule: any = {
    valid: true,
    descricaoRegra: [
      (v: any) => !!v || 'Campo obrigatório',
      (v: any) => (v && v.length <= 100) || 'Máximo de 100 caracteres permitido',
    ],
    valorGarantiaMinima: [(v: any) => !!v || 'Campo obrigatório'],
    prestadorId: [(v: any) => !!v || 'Campo obrigatório'],
    vigenciaInicio: [(v: any) => !!v || 'Campo obrigatório'],
    fontePagadoraIdDestino: [(v: any) => !!v || 'Campo obrigatório'],
    grupoRepasseIdDestino: [(v: any) => !!v || 'Campo obrigatório'],
    profissionalExecutanteIdDestino: [(v: any) => !!v || 'Campo obrigatório'],
    descricaoItemRecebimentoDestino: [
      (v: any) => !!v || 'Campo obrigatório',
      (v: any) => (v && v.length <= 100) || 'Máximo de 100 caracteres permitido',
    ],
  }

  menuInicioVigencia: boolean = false
  menuFimVigencia: boolean = false
  searchPrestador: any = ''
  searchProfissional: any = ''
  filtroProfissional: string = ''
  profissionalName: string = ''
  loadingPrestadorFilter: boolean = false
  ignoreNextPrestadorSearch: boolean = false
  suppressPrestadorSearch: boolean = false
  loadingProfissionalFilter: boolean = false

  profissionaisDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getProfissionais({ nome: param }), 500)
  prestadoresDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getPrestadoresRepasse({ filtro: param, limite: 20 }), 500)

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get mode() { return this.getRegrasDeCalculoStore.mode }

  loadAddRegraCalculo: boolean = false
  get loadingAddRegraCalculo() { return this.loadAddRegraCalculo }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculo = value }

  get showModalRegraGarantiaMinima() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGarantiaMinima }
  set showModalRegraGarantiaMinima(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGarantiaMinima', value }) }

  get gruposRepasse() { return this.getRegrasDeCalculoStore.gruposRepasse }
  get fontesPagadoras() { return this.getRegrasDeCalculoStore.fontesPagadoras }
  get profissionaisExecutantes() { return this.getRegrasDeCalculoStore.profissionaisExecutantes }
  get prestadores() { return this.getRegrasDeCalculoStore.prestadoresRepasse }
  set prestadores(value: any) { this.getRegrasDeCalculoStore.setPrestadoresRepasse(value) }
  get transacaoFinanceiraList() { return this.getRegrasDeCalculoStore.transacaoFinanceiraList }
  get tipoItemDesconsiderado() { return this.getRegrasDeCalculoStore.tiposItemDesconsiderado }

  get getMenuInicioVigencia() { return this.menuInicioVigencia }
  set getMenuInicioVigencia(value: boolean) { this.menuInicioVigencia = value }

  get getMenuFimVigencia() { return this.menuFimVigencia }
  set getMenuFimVigencia(value: boolean) { this.menuFimVigencia = value }

  get formattedInicioVigencia() {
    const { vigenciaInicio } = this.getRegrasDeCalculoStore.regraGarantiaMinimaItem
    if (vigenciaInicio) {
      return this.formatDate(vigenciaInicio)
    }
    return ''
  }

  get formattedFimVigencia() {
    const { vigenciaFim } = this.getRegrasDeCalculoStore.regraGarantiaMinimaItem
    if (vigenciaFim) {
      return this.formatDate(vigenciaFim)
    }
    return ''
  }

  updateFimVigencia(date: string) {
    this.getRegrasDeCalculoStore.regraGarantiaMinimaItem.vigenciaFim = date
  }

  updateInicioVigencia(date: string) {
    this.getRegrasDeCalculoStore.regraGarantiaMinimaItem.vigenciaInicio = date
  }

  formatDate(vigencia: any) {
    const date = new Date(vigencia)
    if (!Number.isNaN(date.getTime())) {
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const year = date.getUTCFullYear()
      return `${day}/${month}/${year}`
    }
    console.error('Data inválida:', vigencia)
    return ''
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  onlyFloatUtil(value: number) { return onlyFloat(value) }

  async addGarantiaMinima() {
    this.loadingAddRegraCalculo = true
    if (!this.$refs.formRegraGarantiaMinima.validate()) {
      this.loadingAddRegraCalculo = false
      return
    }
    const request = await this.getRegrasDeCalculoStore.addGarantiaMinima()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Regra incluída com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.getRegrasDeCalculoStore.setMode('EDIT')
    this.getRegrasDeCalculoStore.setModeModalGarantiaMinima('EDIT')
  }

  closeModal() {
    this.showModalRegraGarantiaMinima = false
    this.getRegrasDeCalculoStore.clearRegraGarantiaMinimaItem()
    this.getRegrasDeCalculoStore.setModeModalGarantiaMinima('CREATE')
    this.$refs.formRegraGarantiaMinima.resetValidation()
  }

  changeProfissionalExecutante(value: any) {
    if (value) {
      this.profissionalName = value.nome
      this.getRegrasDeCalculoStore.regraGarantiaMinimaItem.profissionalExecutanteIdDestino = value.userId
    } else {
      this.profissionalName = ''
    }
  }

  @Watch('showModalPostRegraCalculoContrato')
  onChangeShowModalPostRegraCalculoContrato(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.setPrestadorId('')
      this.getRegrasDeCalculoStore.clearContratos()
    }
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      this.getRegrasDeCalculoStore.setProfissionaisExecutantes([])
      return
    }
    
    if(this.profissionalName === val){
      return
    } else {
      this.filtroProfissional = ''
    }
    
    this.loadingProfissionalFilter = true
    if(this.profissionaisDebounced) await this.profissionaisDebounced(val)
    this.loadingProfissionalFilter = false
  }

  @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (this.suppressPrestadorSearch) {
      return
    }

    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    if (!val || val.length < 3) {
      return
    }

    this.loadingPrestadorFilter = true
    if (this.prestadoresDebounced) await this.prestadoresDebounced(val)
    this.loadingPrestadorFilter = false
  }

  @Watch('showModalRegraGarantiaMinima')
  onChangeShowModalAddRegraGarantiaMinima(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.clearRegraGarantiaMinimaItem()
      this.getRegrasDeCalculoStore.setModeModalGarantiaMinima('CREATE')
      this.$refs.formRegraGarantiaMinima.resetValidation()
    } else {
      if(this.getRegrasDeCalculoStore.regraGarantiaMinimaItem.profissionalExecutanteIdDestino){
        this.getRegrasDeCalculoStore.setProfissionaisExecutantes([{
          userId: this.getRegrasDeCalculoStore.regraGarantiaMinimaItem.profissionalExecutanteIdDestino,
          nome: this.getRegrasDeCalculoStore.regraGarantiaMinimaItem.nomeProfissionalExecutanteDestino,
        }])
      }
    }
  }

  get centroDeCustoList() {
    return this.getRegrasDeCalculoStore.centroDeCusto
  }

  async mounted() {
    await this.getRegrasDeCalculoStore.getGruposRepasse()
    await this.getRegrasDeCalculoStore.getTransacaoFinanceira()
    await this.getRegrasDeCalculoStore.getCentroDeCusto()
    await this.getRegrasDeCalculoStore.getTiposItemDesconsiderado()
  }

  @Watch('showModalRegraGarantiaMinima')
  async onChangeShowModalRegraGarantiaMinimaPrestador(value: boolean) {
    if (value) {
      this.suppressPrestadorSearch = true
      this.searchPrestador = ''
      this.loadingPrestadorFilter = true

      const itemGarantiaMinima = this.getRegrasDeCalculoStore.regraGarantiaMinimaItem
      
      this.prestadores = [{
        userId: itemGarantiaMinima.prestadorId,
        nome: itemGarantiaMinima.razaoSocialPrestador
      }]
      this.loadingPrestadorFilter = false
      this.suppressPrestadorSearch = false
    }
  }

  onChangePrestador() {
    this.ignoreNextPrestadorSearch = true
  }
}
